// @ts-nocheck
/* eslint-disable */
import * as types from 'appRedux/actions/roles';

const initialState = {
  request: false,
  success: false,
  error: '',
  message: null,
  roleList: [],
  addRoleResponse: null,
  permissionList: [],
  permissionByRoleId: [],
  roleDetail: {},
  getAllRolesSuccess: false,
  getAllPermissionSuccess: false,
};

// const getRoleById = (roleList, id) => {
//   return roleList.find(role => +role.id === +id);
// };

// const updateRole = (roleList, action) => {
//   return roleList
//     .filter(role => +role.id !== +action.id)
//     .concat(action.payload);
// };

function rolesMgmtReducer(state = initialState, action = {}) {
  switch (action.type) {
    case types.GET_ALL_ROLES_REQUEST:
      return {
        ...state,
        request: true,
      };

    case types.GET_ALL_ROLES_SUCCESS:
      return {
        ...state,
        request: false,
        getAllRolesSuccess: true,
        roleList: action.payload
          ? action.payload.data.map((datum) => ({
              ...datum,
              // id: datum.id,
              // name: datum.name,
              value: datum.id,
              label: datum.name,
            }))
          : [],
      };

    // case types.GET_ALL_ROLES_REQUEST:
    //   return {
    //     ...state,
    //     request: false,
    //     getAllRolesSuccess: false,
    //     error: action.payload ? action.payload.detail : 'Something went wrong.',
    //   };

    case types.ADD_NEW_ROLES_REQUEST:
      return {
        ...state,
        request: true,
        message: '',
      };

    case types.ADD_NEW_ROLES_SUCCESS:
      return {
        ...state,
        request: false,
        success: true,
        roleList: [...state.roleList, action.payload.data],
        message: `${action.payload.data.name} created successfully`,
      };

    case types.GET_ALL_PERMISSIONS_REQUEST:
      return {
        ...state,
        request: true,
      };

    case types.GET_ALL_PERMISSIONS_SUCCESS:
      return {
        ...state,
        request: false,
        getAllPermissionSuccess: true,
        permissionList: action.payload ? action.payload.permissions : {},
      };

    case types.GET_ROLE_BY_ID_SUCCESS:
      return {
        ...state,
        roleDetail: action.payload.data[0],
      };

    case types.UPDATE_ROLE_BY_ID_REQUEST:
      return {
        ...state,
        request: true,
      };

    default: {
      return state;
    }
  }
}
export default rolesMgmtReducer;
